function Argentina({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_530)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0V0Z" fill="#338AF3"/>
        <path d="M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65664 32 16 32Z" fill="#338AF3"/>
        <path d="M20.7821 16L18.8281 16.9192L19.8686 18.8116L17.7468 18.4057L17.4779 20.5492L16 18.9727L14.522 20.5492L14.2531 18.4057L12.1313 18.8116L13.1718 16.9191L11.2178 16L13.1718 15.0808L12.1313 13.1884L14.2531 13.5943L14.522 11.4508L16 13.0273L17.478 11.4508L17.7468 13.5943L19.8687 13.1884L18.8281 15.0809L20.7821 16Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Argentina;
